export enum ReadingTypeSequentialOptions{
  AUTO= "AUTO",
  MANUAL = "MANUAL",
}
